import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/axios';

const ProtectedRoute = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/enquiries', { params: { limit: 1 } })
      .then(() => setChecking(false))
      .catch(() => navigate('/admin/login'));
  }, [navigate]);

  if (checking) {
    return <div className="min-h-screen flex items-center justify-center text-lg">Checking authentication...</div>;
  }
  return children;
};

export default ProtectedRoute; 